<template>
    <md-image class="logo" :class='{"logo-col": isCollapse}' :src="url" fit="fill" @click="goHome"></md-image>
</template>
<!-- eslint-disable global-require -->
<script>
export default {
    name: 'Logo',
    props: {
        isCollapse: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        url() {
            if (this.isCollapse) {
                return require('@/assets/home/logo-col.svg');
            }
            return require('@/assets/home/logo.svg');
        },
    },
    methods: {
        goHome() {
            this.$router.push({ path: '/' });
        },
    },
};
</script>
<style lang="less" scoped>
@import url("../../../../../styles/vars.less");
.logo {
    width: 100%;
    height: @header-height;
    padding: 0 11px;
    cursor: pointer;
}
.logo-col {
    padding: 0px 10px;
    cursor: pointer;
}
</style>
